module.exports = __webpack_public_path__ + "static/media/NIFTYFINSERVICE.f33053aa.txt";